export default __webpack_public_path__ + "static/media/favicon.0a76eee1.png";